import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';

const LS_DONE = 'onboarding_done';

function isOnboardingCompleted(): boolean {
  try {
    return localStorage.getItem(LS_DONE) === 'true';
  } catch {
    return false;
  }
}

export const onboardingStartupGuard: CanMatchFn = () => {
  const router = inject(Router);
  if (isOnboardingCompleted()) {
    return router.createUrlTree(['/login']);
  }
  return true;
};
